import { Component, Input, OnInit } from '@angular/core';
import { MenuGroupItem } from '../interfaces';

@Component({
	selector    : 'menu-header-cta-logo',
	templateUrl : './header-cta-logo.component.html',
	styleUrls   : ['./header-cta-logo.component.scss']
})
export class HeaderCtaLogoComponent implements OnInit {

	@Input() public mainStructure : MenuGroupItem[];

	public home : MenuGroupItem;

	constructor()
	{
	}

	ngOnInit()
	{
		this.home = this.mainStructure.find(item => item.item_name === 'home');
	}
}
